<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00001 9.41415L13.657 15.0711C13.8456 15.2533 14.0982 15.3541 14.3604 15.3518C14.6226
      15.3495 14.8734 15.2444 15.0588 15.059C15.2442 14.8736 15.3494 14.6227 15.3517 14.3606C15.354
      14.0984 15.2532 13.8458 15.071 13.6571L9.41401 8.00015L15.071 2.34315C15.2532 2.15455 15.354
      1.90194 15.3517 1.63975C15.3494 1.37755 15.2442 1.12674 15.0588 0.941331C14.8734 0.755923
      14.6226 0.650754 14.3604 0.648475C14.0982 0.646197 13.8456 0.746991 13.657 0.929149L8.00001
      6.58615L2.34301 0.929149C2.15356 0.751494 1.90242 0.654515 1.64274 0.658732C1.38305 0.662948
      1.1352 0.768031 0.951616 0.951743C0.768033 1.13546 0.663126 1.38339 0.659093 1.64307C0.65506
      1.90276 0.752217 2.15382 0.930006 2.34315L6.58601 8.00015L0.929006 13.6571C0.833496 13.7494
      0.757314 13.8597 0.704905 13.9817C0.652496 14.1037 0.62491 14.235 0.623756 14.3677C0.622602
      14.5005 0.647904 14.6322 0.698185 14.7551C0.748465 14.878 0.822719 14.9897 0.916611
      15.0835C1.0105 15.1774 1.12216 15.2517 1.24505 15.302C1.36795 15.3523 1.49963
      15.3776 1.63241 15.3764C1.76519 15.3752 1.89641 15.3477 2.01841 15.2953C2.14041
      15.2428 2.25076 15.1667 2.34301 15.0711L8.00001 9.41415Z"
      fill="currentColor"/>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
